import {
  FETCH_ONBOARDING_REQUEST,
  FETCH_ONBOARDING_SUCCESS,
  FETCH_ONBOARDING_FAILURE,
  UPDATE_ONBOARDING_REQUEST,
  UPDATE_ONBOARDING_SUCCESS,
  UPDATE_ONBOARDING_FAILURE,
  COMPLETE_GOAL_REQUEST,
  COMPLETE_GOAL_SUCCESS,
  COMPLETE_GOAL_FAILURE,
  DISMISS_ONBOARDING_REQUEST,
  DISMISS_ONBOARDING_SUCCESS,
  DISMISS_ONBOARDING_FAILURE
} from '../actions/onboarding.actions';

const initialState = {
  data: null,
  loading: false,
  updating: false,
  error: null
};

export default function onboarding(state = initialState, action) {
  switch (action.type) {
    case FETCH_ONBOARDING_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ONBOARDING_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_ONBOARDING_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_ONBOARDING_REQUEST:
      return { ...state, updating: true, error: null };
    case UPDATE_ONBOARDING_SUCCESS:
      return { ...state, updating: false, data: action.payload };
    case UPDATE_ONBOARDING_FAILURE:
      return { ...state, updating: false, error: action.payload };

    case COMPLETE_GOAL_REQUEST:
      return { ...state, updating: true, error: null };
    case COMPLETE_GOAL_SUCCESS:
      return { ...state, updating: false, data: action.payload };
    case COMPLETE_GOAL_FAILURE:
      return { ...state, updating: false, error: action.payload };

    case DISMISS_ONBOARDING_REQUEST:
      return { ...state, updating: true, error: null };
    case DISMISS_ONBOARDING_SUCCESS:
      return { ...state, updating: false, data: { ...state.data, should_show: false } };
    case DISMISS_ONBOARDING_FAILURE:
      return { ...state, updating: false, error: action.payload };

    default:
      return state;
  }
}

export const getOnboarding = state => state?.onboarding?.data;
export const getOnboardingLoading = state => state?.onboarding?.loading;
export const getOnboardingUpdating = state => state?.onboarding?.updating;
export const getShouldShowOnboarding = state => state?.onboarding?.data?.should_show;
export const getCompletedGoals = state => state?.onboarding?.data?.completed_goals || [];
